import { BaseDto } from './base.dto';
import { ConfigurationTypeDto } from './configurationType.dto';
import { MerchantDto } from './merchant.dto';
export class MerchantConfigurationDto extends BaseDto{
  
    merchant: MerchantDto;


    group?: string;

    configurationType: ConfigurationTypeDto;


    value?: string;
}